import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const PARTICIPANT_POST_REQUEST = 'POST_PARTICIPANT_REQUEST';
export const PARTICIPANT_POST_FAILURE = 'POST_PARTICIPANT_FAILURE';
export const PARTICIPANT_POST_SUCCESS = 'POST_PARTICIPANT_SUCCESS';

/**
 * `competition` (an id) lets the category list re-read its counts and draw
 * marks. Resolves true when the entry was created.
 */
export const postParticipant = (data, competition = null) => {
    return function(dispatch) {
        dispatch(postRequest());
        return axios(apiRequestOptions(apiPath.PARTICIPANT.POST, data))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(postSuccess(response.data, competition));
                dispatch(addSuccessMessage('Participant successfully added'));

                return true;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));

                return false;
            });
    }
};

const postRequest = () => {
    return {
        type: PARTICIPANT_POST_REQUEST,
    }
};

const postFailure = (error) => {
    return {
        type: PARTICIPANT_POST_FAILURE,
        error,
    }
};

const postSuccess = (participant, competition) => {
    return {
        type: PARTICIPANT_POST_SUCCESS,
        participant,
        competition,
    }
};